import React from 'react';
import throttle from 'lodash/throttle';

interface Props {
  elements: HTMLElement[];
  onScrollTo: (element: HTMLElement) => void;
  // Use to fire event when scroll down earlier
  offsetTop?: number;
}

const defaultProps = {
  offsetTop: 0,
};
const THROTTLE_TIMEOUT = 300;

class OnScrollToElement extends React.Component<Props> {
  current: HTMLElement;

  static defaultProps = defaultProps;

  render() {
    return null;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScrollToElement);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScrollToElement);
  }

  getTopVisibleElement() {
    const { offsetTop, elements } = this.props;

    const topVisibleElement = elements.find(elem => {
      if (elem instanceof HTMLElement) {
        const { top, height } = elem.getBoundingClientRect();
        return top + height - offsetTop! > 0;
      }
      return false;
    });

    if (topVisibleElement) {
      return topVisibleElement;
    }

    return elements[elements.length - 1];
  }

  handleOnScrollToElement = throttle(
    () =>
      requestAnimationFrame(() => {
        const { onScrollTo } = this.props;
        const topVisibleElement = this.getTopVisibleElement();

        if (this.current !== topVisibleElement) {
          this.current = topVisibleElement;
          onScrollTo(topVisibleElement);
        }
      }),
    THROTTLE_TIMEOUT,
    { leading: false }
  );
}

export default OnScrollToElement;
